export default {
    "navigation": {
        "allWatchfaces": "Все приложения",
        "faq": "Часто задаваемые вопросы",
        "helpCenter": "Помощь и инструкции",
        "newsletter": "Рассылка",
        "contact": "Контакты",
        "weatherProvider": "Погодный провайдер",
        "tides": "Приливы",
        "colors": "Цвета",
        "fonts": "Шрифты"
    },
    "homepage": {
        "title": "Приложения TitanicTurtle",
        "subtitle": "Современные приложения Garmin с расширенными функциями для всех ваших активностей",
        "features": {
            "tides": "🌊 Приливы",
            "weather": "🌤️ Погода",
            "themes": "🎨 Цветовые темы",
            "gps": "📍 GPS"
        },
        "availableWatchfaces": "Доступные циферблаты",
        "newBadge": "Новинка",
        "loading": "Загрузка циферблатов...",
        "error": "Ошибка загрузки",
        "retry": "Повторить",
        "filter": {
            "label": "Фильтр продуктов",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "Все",
            "noProducts": "Нет продуктов в этой категории"
        }
    },
    "watchface": {
        "purchase": "Купить сейчас",
        "buy": "Купить",
        "features": "Возможности",
        "colorThemes": "Цветовые темы",
        "themeDescription": "Нажмите на тему, чтобы скопировать строку темы и использовать её в настройках циферблата.",
        "dynamicThemeSwitching": "Динамическое переключение тем",
        "sunsetSwitching": {
            "title": "🌅 После заката / до рассвета",
            "description": "Поставьте восклицательный знак ! перед строкой темы для автоматического переключения после заката (пример: !UEUE[UEUEEEEEEU^)."
        },
        "lowPowerSwitching": {
            "title": "🔋 В режиме энергосбережения",
            "description": "Поставьте решётку # перед строкой темы для режима энергосбережения (пример: #UEUE[UEUEEEEEEU^)."
        },
        "themeCopied": "Строка темы скопирована в буфер обмена!",
        "viewDetails": "Подробнее"
    },
    "faq": {
        "title": "Часто задаваемые вопросы",
        "subtitle": "Ответы на распространённые вопросы о наших циферблатах",
        "tabs": {
            "search": "Поиск",
            "categories": "Категории",
            "all": "Показать все вопросы"
        },
        "category": {
            "selected": "Выбранная категория",
            "showing": "Показано",
            "items": "записей",
            "from": "из",
            "clear": "Сбросить выбор",
            "back": "Назад к категориям"
        },
        "viewAnswer": "Показать ответ",
        "closeAnswer": "Закрыть ответ",
        "darkMode": {
            "enable": "Включить тёмную тему",
            "disable": "Выключить тёмную тему",
            "light": "Светлая",
            "dark": "Тёмная"
        },
        "search": {
            "placeholder": "Поиск по справке...",
            "button": "Искать",
            "suggestions": "Популярные запросы",
            "tips": {
                "title": "Советы по поиску",
                "keywords": "Используйте конкретные слова, например «GPS», «погода» или «настройки»",
                "language": "Поиск работает на выбранном языке",
                "categories": "Просматривайте категории для структурированной справки"
            }
        },
        "noResults": {
            "title": "Ничего не найдено",
            "description": "Попробуйте другие слова или просмотрите категории",
            "browseCategories": "Просмотреть категории"
        },
        "suggestions": {
            "title": "Популярные запросы"
        },
        "trending": {
            "title": "Популярные запросы"
        },
        "categories": {
            "title": "Просмотр по категориям",
            "items": "записей",
            "allItems": "Все вопросы",
            "allItemsDescription": "Просмотр всех часто задаваемых вопросов",
            "noItems": {
                "title": "В этой категории нет записей",
                "description": "Попробуйте выбрать другую категорию"
            },
            "viewMore": "Показать все записи"
        },
        "results": {
            "title": "Результаты поиска",
            "found": "результатов по запросу",
            "total": "Всего результатов",
            "bestMatch": "Лучшее совпадение",
            "categories": "Категории",
            "sortBy": "Сортировка",
            "sort": {
                "relevance": "По релевантности",
                "priority": "По приоритету",
                "category": "По категории"
            },
            "lastUpdated": "Обновлено",
            "matchedIn": "Совпадение в",
            "footer": "Не нашли то, что искали?",
            "browseCategories": "Просмотреть категории",
            "viewTrending": "Популярные запросы",
            "contactSupport": "Связаться с поддержкой"
        },
        "actions": {
            "copy": "Копировать",
            "share": "Поделиться",
            "copyAnswer": "Копировать ответ",
            "copyAll": "Копировать всё"
        },
        "loading": "Загрузка вопросов...",
        "error": "Ошибка загрузки",
        "retry": "Повторить",
        "questions": {
            "gpsFix": {
                "question": "Что такое GPS-фиксация и как её выполнить? / Почему некоторые опции показывают «GPS?»",
                "answer": "GPS-фиксация нужна, чтобы циферблат знал ваше местоположение и правильно рассчитывал время восхода/заката и луны.\n\nФиксацию можно выполнить, запустив активность и дождавшись получения GPS-сигнала часами, или долгим нажатием кнопки GPS до получения сигнала.\n\nПосле этого вернитесь на циферблат — данные должны отображаться корректно."
            },
            "userData": {
                "question": "Собирают ли циферблаты пользовательские данные?",
                "answer": "Циферблаты TitanicTurtle не собирают пользовательские данные и никуда их не передают. Они только отображают данные, предоставленные Garmin, или выполняют расчёты на их основе (например, активные калории).\n\nВ целом все данные, которые Garmin передаёт сторонним циферблатам, не персонализированы — имени и подобной информации в них нет."
            },
            "permissions": {
                "question": "Зачем циферблатам столько разрешений?",
                "answer": "Циферблатам TitanicTurtle нужны разрешения для предоставления широкого набора данных и функций.\n\nРазъяснение каждого:\n\n<b>Работа в фоне при неактивности</b> — нужно для обновления данных приливов и погоды от сторонних провайдеров в сочетании с разрешением на интернет.\n\n<b>Отправка и получение данных через интернет</b> — нужно для обновления данных приливов и погоды в сочетании с работой в фоне.\n\n<b>Чтение и отображение данных других приложений</b> — другие приложения должны явно предоставлять данные для чтения циферблатами. Сюда входят приложения Garmin, например «Стресс» или Body Battery, которые обновляются в реальном времени. Несанкционированные данные других приложений прочитать нельзя.\n\n<b>Местоположение GPS</b> — нужно для расчёта времени восхода/заката, восхода/захода луны и корректного погодного местоположения.\n\n<b>История пульса, барометра, температуры и высоты</b> — данные, отображаемые на циферблате, только для показа.\n\n<b>Фитнес-профиль Garmin Connect™</b> — нужен для отображения веса, расчёта активных калорий и включения энергосбережения по заданному времени сна.\n\nПерсональных данных вроде имени или адресов циферблаты не читают.\n\nК сожалению, эти разрешения нельзя настроить под использование циферблата — они всегда требуются."
            },
            "proFeatures": {
                "question": "Что означает ♛ и почему некоторые экраны показывают «key»?",
                "answer": "♛ обозначает премиум-функции циферблата. Чтобы разблокировать их после 5-дневного пробного периода, можно купить ключ разблокировки.\n\n«key?» означает, что пробный период закончился."
            },
            "temperatureUnits": {
                "question": "Как изменить единицы температуры?",
                "answer": "Зайдите в системные настройки часов (долгое нажатие кнопки меню): Система → Формат → Единицы и измените там."
            },
            "timeFormat": {
                "question": "Как установить формат 12ч/24ч?",
                "answer": "Зайдите в системные настройки часов (долгое нажатие кнопки меню): Система → Формат → Формат времени и измените там."
            },
            "distanceUnits": {
                "question": "Как изменить единицы расстояния или высоты?",
                "answer": "Зайдите в системные настройки часов (долгое нажатие кнопки меню): Система → Формат → Единицы и измените там."
            }
        }
    },
    "helpCenter": {
        "title": "Помощь и инструкции",
        "subtitle": "Ответы, руководства и инструкции по вашему циферблату",
        "guidesTitle": "Руководства и инструкции",
        "faqTitle": "Часто задаваемые вопросы",
        "allCategories": "Все",
        "guides": "Руководства",
        "faqResults": "Вопросы",
        "noResults": "Ничего не найдено",
        "noResultsHint": "Попробуйте другие слова или просмотрите категории и руководства ниже."
    },
    "guides": {
        "backToHelp": "Назад",
        "purchase": {
            "title": "Покупка и установка",
            "tabs": {
                "installation": "Установка",
                "versions": "Версии VX / Elite",
                "troubleshooting": "Решение проблем"
            },
            "installation": {
                "title": "Установка циферблатов через приложение ConnectIQ",
                "intro": "Циферблаты можно установить на часы через приложение Garmin ConnectIQ для Android или iOS.",
                "step1": "Подключите часы к телефону по Bluetooth и откройте приложение ConnectIQ на телефоне.",
                "step2": "Перейдите на страницу циферблата, который хотите установить.",
                "step3": "Нажмите кнопку «Установить». Циферблат будет добавлен в очередь загрузки и установится на часы.",
                "step4": "После установки вы увидите сообщение в приложении или на часах, и циферблат будет доступен на устройстве.",
                "noteScreen": "Убедитесь, что экран телефона не гаснет и приложение ConnectIQ остаётся открытым во время установки и обновлений.",
                "selectWatchfaceTitle": "Выбор циферблата на часах",
                "selectWatchfaceIntro": "Если циферблат установлен, но ещё не отображается, возможно, нужно выбрать его в системном меню часов.",
                "select1": "Нажмите и удерживайте кнопку меню на часах (или соответствующую кнопку на сенсорных устройствах), чтобы открыть системное меню.",
                "select2": "Перейдите к пункту «Циферблаты» или «Дизайн экрана».",
                "select3": "Вы увидите список установленных циферблатов. Используйте кнопки вверх/вниз или сенсорный экран для навигации.",
                "select4": "Подтвердите выбранный циферблат кнопкой в правом верхнем углу. Циферблат активирован на часах."
            },
            "versions": {
                "title": "VX и Elite — в чём разница?",
                "sameFeatures": "Технически обе версии идентичны и имеют одинаковый функционал. Разница только в способе покупки и активации.",
                "eliteTitle": "Версия Elite (Garmin Pay)",
                "elite1": "Отдельная установка циферблата, купленного напрямую через Garmin Pay в магазине ConnectIQ.",
                "elite2": "Версия Elite привязана к аккаунту Garmin. При покупке новых часов вы сможете снова установить циферблат Elite без дополнительного ключа.",
                "elite3": "Garmin Pay поддерживается не на всех моделях часов и может быть недоступен в некоторых странах.",
                "eliteNoKey": "Важно: при покупке версии Elite через Garmin Pay код разблокировки не отправляется. Версия Elite разблокируется сразу после покупки и не требует кода.",
                "vxTitle": "Версия VX / с сайта",
                "vx1": "Совместима с большим числом устройств и часто доступна там, где Garmin Pay недоступен.",
                "vx2": "Включает встроенный бесплатный пробный период в несколько дней.",
                "vx3": "После пробного периода можно купить код разблокировки на этом сайте для постоянной разблокировки версии VX (или её премиум-функций).",
                "vx4": "Код разблокировки действителен только для устройства, для которого был куплен (WatchfaceID).",
                "vx5": "Если часы заменены по гарантии Garmin, можно сгенерировать новый ключ. В этом случае обратитесь в поддержку через форму обратной связи."
            },
            "website": {
                "title": "Покупка через сайт (VX / обычные версии)",
                "step1": "Сначала установите циферблат на часы (см. вкладку «Установка»). WatchfaceID появляется в настройках циферблата только после установки.",
                "step2": "Откройте настройки циферблата (через приложение ConnectIQ или Garmin Express) и скопируйте WatchfaceID из верхнего поля.",
                "step3": "На этом сайте выберите нужный циферблат и введите свой WatchfaceID в форму покупки.",
                "step4": "Завершите оплату. Вы получите код разблокировки по email и сможете ввести его в поле ключа в настройках циферблата.",
                "noteNoAutoInstall": "Важно: покупка кода разблокировки на сайте не устанавливает циферблат на часы автоматически. Шаги установки нужно выполнить вручную."
            },
            "troubleshooting": {
                "installationTitle": "Проблемы с установкой (очередь / зависшие обновления)",
                "installationIntro": "Иногда установка не удаётся, циферблат долго остаётся в очереди или приложение ConnectIQ сообщает о бесконечных обновлениях.",
                "installationCause": "Обычно это связано с приложением ConnectIQ или сервисами Garmin, а не с самим циферблатом.",
                "installationFix1": "Перезагрузите часы и перезапустите приложение ConnectIQ на телефоне.",
                "installationFix2": "Попробуйте установку снова и убедитесь, что экран телефона не гаснет и приложение ConnectIQ остаётся открытым во время процесса.",
                "garminPayTitle": "Покупка через Garmin Pay зависла в состоянии «в процессе»",
                "garminPayText": "Если покупка через Garmin Pay в магазине ConnectIQ долго остаётся в состоянии «в процессе», это полностью обрабатывается Garmin. Как разработчик, мы не можем влиять на систему Garmin Pay. В таком случае обратитесь в официальную поддержку Garmin.",
                "noKeyTitle": "Я не получил ключ разблокировки после покупки на сайте",
                "noKey1": "Сначала проверьте папку «Спам» в почте. Письма с ключами часто попадают туда.",
                "noKey2": "Часто доставке мешает опечатка в email. Если письмо не найдёте — свяжитесь с нами.",
                "noKey3": "и укажите email, использованный для оплаты, и по возможности WatchfaceID.",
                "noKeyElite": "Примечание: при покупке версии Elite напрямую через Garmin Pay в магазине ConnectIQ код разблокировки не отправляется. Версия Elite разблокируется сразу после покупки и не требует кода."
            },
            "contactLink": "Форма обратной связи"
        },
        "timezones": {
            "title": "Часовые пояса и смещение UTC",
            "basicsTitle": "Что такое 2-й и 3-й часовые пояса?",
            "basicsText": "Во многих циферблатах можно настроить два дополнительных часовых пояса. Обычно они называются «Второй часовой пояс» и «Третий часовой пояс» и отображаются в отдельных полях на циферблате.",
            "offsetTitle": "Настройка смещений UTC",
            "offsetIntro": "В настройках циферблата обычно есть поле, куда можно ввести смещения второго и третьего часового пояса в минутах относительно UTC.",
            "offsetFormat": "Первое значение — смещение второго пояса, второе — третьего. Значения указываются в минутах через пробел. Плюс не добавляется автоматически, положительные значения вводятся без +.",
            "exampleLabel": "Пример:",
            "exampleExplanation": "Здесь второй пояс имеет смещение −4,5 часа (−270 минут), третий — +2 часа (+120 минут) относительно UTC.",
            "changeExample": "Если нужно изменить второй пояс на +6 часов, первое значение должно быть 360 (6 × 60). В нашем примере получится:",
            "advancedTitle": "Дополнительные опции (суффиксы A/B/C)",
            "advancedOptionalHint": "Этот раздел необязателен. Актуален только если циферблат поддерживает суффиксы формата A/B/C.",
            "advancedIntro": "Поддержка этих суффиксов указана в описании над полем смещения в настройках циферблата. Если поддерживается, описание может быть таким:",
            "advancedExample": "Смещение UTC 2-го и 3-го пояса в минутах (через пробел) (буквы после смещений: A — 12ч, B — 24ч, C — военный формат, пусто — по умолчанию)",
            "advancedNote": "Эти необязательные буквы (A/B/C) на некоторых циферблатах задают формат отображения времени для соответствующего пояса. Используйте их только если описание циферблата это упоминает и вам нужен другой формат. Большинству достаточно числовых смещений без букв.",
            "exampleSectionTitle": "Пошагово: пример для разных городов и форматов",
            "exampleIntro": "Ниже показано, как задать второй пояс (например Нью-Йорк) и третий (например Токио) и при необходимости выбрать 12- или 24-часовой формат для каждого.",
            "exampleStep1Title": "Шаг 1: смещение UTC для 2-го пояса",
            "exampleStep1Text": "Выберите город или регион для второго пояса. Переведите разницу во времени с UTC в минуты. Пример: Нью-Йорк (EST, UTC−5) → −300 минут. Введите это как первое значение в настройках.",
            "exampleStep2Title": "Шаг 2: смещение UTC для 3-го пояса",
            "exampleStep2Text": "То же для третьего пояса. Пример: Токио (JST, UTC+9) → 540 минут. Это второе значение, через пробел после первого.",
            "exampleOnlyOffsets": "Если циферблат не использует суффиксы A/B/C, настройка готова. Введите:",
            "exampleStep3Title": "Шаг 3: необязательный суффикс формата (A/B/C)",
            "exampleStep3Optional": "Шаг необязателен: суффиксы можно не указывать даже при поддержке; тогда используется формат по умолчанию. Чтобы задать 12ч, 24ч или военный формат для пояса, добавьте букву сразу после смещения — без пробела между смещением и суффиксом.",
            "exampleStep3Text": "Пример: 12-часовой формат для Нью-Йорка (A) и 24-часовой для Токио (B):",
            "exampleStep3Note": "Без суффикса используется формат по умолчанию циферблата (часто 24ч). Поддержка суффиксов указана в описании над полем смещения в настройках циферблата.",
            "exampleFormatTitle": "Как отображается время при A, B, C",
            "exampleFormatIntro": "Для одного и того же момента время отображается по-разному в зависимости от формата (пример: 2-й пояс Нью-Йорк -300, 3-й Токио 540). Предпросмотр:",
            "zone2": "2-й пояс",
            "zone3": "3-й пояс",
            "exampleTableTitle": "Справка: смещения UTC для выбранных городов (минуты)",
            "exampleTableIntro": "Стандартное время; летнее может отличаться. Умножьте часы на 60."
        },
        "switchViews": {
            "title": "Переключение видов и жесты",
            "wordLabel": "переключение вида",
            "basicsTitle": "Что такое переключение видов?",
            "basicsText": "Многие циферблаты показывают разную информацию в одной области экрана. Эти альтернативные экраны в настройках часто называются «Switchview» ({{wordLabel}}), «Switchview 2», «Верхний вид 1/2», «Нижний вид 1/2» и т.п.",
            "proNote": "Часто эти дополнительные виды — премиум-функции, доступные в пробный период и требующие ключа активации после него.",
            "gestureTitle": "Переключение видов жестом запястья",
            "gestureIntro": "На часах без совместимого сенсорного экрана альтернативные виды переключаются вторым движением запястья.",
            "gestureStep1": "Поднимите запястье как обычно, чтобы разбудить экран. Секунды или подсветка показывают, что часы в активном режиме.",
            "gestureStep2": "В течение нескольких секунд (около 7) снова выполните движение запястьем — не слишком резко, но достаточно чётко, чтобы часы распознали его как второй жест.",
            "gestureStep3": "Если циферблат поддерживает переключение видов, настроенные области (например верхний или нижний вид) переключатся на следующую страницу.",
            "gestureHint": "Если ничего не меняется, проверьте настройки циферблата: некоторым видам нужно явно назначить (например «Верхний вид 2» / «Нижний вид 2»).",
            "touchTitle": "Переключение видов на сенсорных устройствах",
            "touchIntro": "На новых часах с совместимым сенсорным экраном (например Fenix 7 и новее) виды часто можно переключать нажатием определённых зон.",
            "touchConfig": "Во многих циферблатах эти зоны настраиваются в параметрах, обычно ниже по списку. Типичные примеры — цифры часов и минут или отдельные области экрана.",
            "touchHold": "Если зона нажатия настроена, долгое нажатие на соответствующую цифру/область переключает назначенный вид.",
            "touchMultiple": "В некоторых циферблатах есть несколько зон с отдельным назначением — например одна для верхнего вида, одна для нижнего.",
            "touchInfo": "Если у циферблата есть особые зоны, они обычно описаны в информационном тексте на этом сайте или в магазине ConnectIQ."
        },
        "findWfId": {
            "title": "Как найти свой WatchfaceID",
            "whatIs": "Что такое WatchfaceID?",
            "whatIsExplanation": "У каждого циферблата на каждом устройстве свой WatchfaceID — число из 5–6 цифр. Этот ID нужен для покупки кода активации или обращения в поддержку.",
            "connectIqTitle": "Через приложение ConnectIQ (рекомендуется)",
            "ciq1": "Убедитесь, что часы подключены к телефону по Bluetooth.",
            "ciq2": "Откройте приложение ConnectIQ на телефоне.",
            "ciq3": "Перейдите на страницу циферблата с описанием и изображениями. Если не находите — используйте строку «Поиск» внизу или раздел «Мои циферблаты» в «Устройстве».",
            "ciq4": "Нажмите кнопку «Настройки» на странице циферблата, чтобы открыть все параметры.",
            "ciq5": "WatchfaceID отображается в верхнем поле. Скопируйте или введите это число — это ID для оплаты.",
            "keyEntryTitle": "Ввод ключа активации",
            "keyEntryExplanation": "В строке под полем WatchfaceID находится поле для ключа/кода, который приходит после оплаты. В некоторых циферблатах там показываются оставшиеся дни пробного периода — удалите это перед вводом ключа.",
            "garminExpressTitle": "Через Garmin Express (компьютер)",
            "ge1": "Установите Garmin Express и подключите часы к компьютеру.",
            "ge2": "Перейдите к списку установленных циферблатов.",
            "ge3": "Нажмите кнопку с тремя точками рядом с циферблатом, чтобы открыть настройки.",
            "ge4": "Действуйте так же, как в приложении ConnectIQ.",
            "geNote": "Примечание: рекомендуется использовать приложение ConnectIQ — некоторые версии Garmin Express могут давать сбои.",
            "zeroId": "WatchfaceID показывает 0?",
            "zeroIdExplanation": "Иногда WatchfaceID показывает 0. Обычно помогает однократное сохранение настроек или перезагрузка часов. Если после этого по-прежнему 0, оплата всё равно должна проходить."
        },
        "location": {
            "title": "Настройка GPS и местоположения",
            "whatIsGpsFix": "Что такое GPS-фиксация?",
            "gpsFixExplanation": "GPS-фиксация сообщает циферблату ваше местоположение, чтобы он мог корректно рассчитывать время восхода/заката, фазы луны, погодное местоположение и приливы.",
            "howTo": "Как выполнить GPS-фиксацию",
            "step1": "На часах перейдите на экран запуска любой активности (например «Бег»)",
            "step2": "Дождитесь получения GPS-сигнала (зелёная полоса/иконка)",
            "step3": "Вернитесь на циферблат — данные должны обновиться в течение нескольких минут",
            "alternative": "Альтернатива: GPS телефона",
            "alternativeExplanation": "Можно включить GPS на телефоне. Часы должны быть подключены по Bluetooth. Этот способ медленнее, но так же работает.",
            "requirements": "Требования",
            "req1": "Часы подключены к телефону по Bluetooth",
            "req2": "Приложение Garmin Connect (не ConnectIQ) работает хотя бы в фоне",
            "req3": "Включён GPS на телефоне для определения по телефону"
        },
        "settings": {
            "tabs": { "options": "Опции полей данных", "change": "Изменить настройки", "troubleshoot": "Устранение неполадок" },
            "title": "Настройки циферблата",
            "optionsIntro": "Общий список опций полей данных. Нажмите для описания. Не все опции доступны на всех циферблатах.",
            "change": {
                "title": "Как изменить настройки циферблата",
                "intro": "Настройки циферблата меняются в приложении ConnectIQ на телефоне.",
                "step1": "Подключите часы к телефону по Bluetooth и откройте приложение ConnectIQ (не Connect).",
                "step2": "Перейдите на страницу циферблата. Если не установлен — сначала установите.",
                "step3": "На странице циферблата нажмите кнопку «Настройки» — откроется список.",
                "step4": "Здесь можно изменить все поля данных, цвета и расширенные опции.",
                "step5": "Нажмите кнопку сохранения в правом верхнем углу, чтобы передать настройки на часы.",
                "installLink": "Инструкция по установке"
            },
            "troubleshoot": {
                "title": "Устранение неполадок",
                "cantSave": { "q": "Настройки не сохраняются", "a1": "Иногда серверы Garmin не обрабатывают некоторые символы.", "a2": "Очистите поле цветовой схемы (если есть) и сохраните снова." },
                "wontOpen": { "q": "Настройки не открываются", "a1": "Полностью закройте приложение ConnectIQ и при необходимости перезапустите часы.", "a2": "Если видите только кнопку «Установить» — циферблат ещё не установлен." },
                "missingOptions": { "q": "Не могу найти нужную опцию", "a": "Не все опции доступны на всех устройствах." },
                "naValue": { "q": "В поле отображается только «n/a»", "a": "Ваше устройство не поддерживает эту опцию (старая модель или отсутствует оборудование)." }
            }
        },
        "dateFormat": {
            "title": "Пользовательский формат даты (Дата 1 / 2 / 3)",
            "basicsTitle": "Для чего поля формата даты?",
            "basicsIntro": "В настройках циферблата есть два (или три) поля, которыми настраивается отображение Даты 1, Даты 2 и при наличии Даты 3. Введённые буквы задают формат.",
            "notAll": "Доступно не на всех циферблатах.",
            "where": "Поля обычно находятся ниже в настройках, под опциями полей данных.",
            "codesTitle": "Коды формата",
            "codesIntro": "В поле формата можно использовать следующие буквы. Результат соответствует текущей дате.",
            "codeD": "день месяца (с ведущим нулём)",
            "codeDText": "день недели текстом (напр. понедельник)",
            "codeM": "месяц числом (с ведущим нулём)",
            "codeMText": "месяц текстом",
            "codeY": "год двумя цифрами",
            "codeY4": "год четырьмя цифрами",
            "codeJ": "юлианская дата (военная)",
            "codeW": "номер недели",
            "codeO": "месяц без ведущего нуля",
            "codeN": "день без ведущего нуля",
            "codeP": "день года",
            "exampleHint": "Напр. «D, d.M.Y» может показать «Пн, 27.02.2026»."
        }
    },
    "newsletter": {
        "title": "Рассылка",
        "description": "Подпишитесь, чтобы получать новости о новых циферблатах, функциях и акциях.",
        "frequencyHint": "Примерно одно письмо раз в два месяца. Отписаться можно в любой момент.",
        "emailPlaceholder": "Ваш email",
        "subscribe": "Подписаться",
        "unsubscribe": "Отписаться",
        "subscribeSuccess": "Подписка оформлена! Проверьте почту.",
        "subscribeError": "Произошла ошибка. Попробуйте позже.",
        "unsubscribeSuccess": "Вы отписаны от рассылки.",
        "unsubscribeError": "Произошла ошибка. Попробуйте позже."
    },
    "contact": {
        "title": "Контакты",
        "description": "Есть вопрос или нужна поддержка? Напишите нам.",
        "emailLabel": "Email",
        "emailPlaceholder": "ваш@email.com",
        "deviceLabel": "Устройство (необязательно)",
        "devicePlaceholder": "напр. Fenix 7",
        "watchfaceLabel": "Циферблат (необязательно)",
        "watchfacePlaceholder": "напр. Horizon",
        "messageLabel": "Сообщение",
        "messagePlaceholder": "Ваше сообщение...",
        "send": "Отправить сообщение",
        "sendAnother": "Отправить ещё сообщение",
        "successTitle": "Сообщение отправлено!",
        "successMessage": "Я отвечу вам как можно скорее.",
        "error": "Произошла ошибка. Попробуйте снова или напишите напрямую на dev@orcatec.net.",
        "consentNotice": "Отправляя форму, вы соглашаетесь на обработку данных в соответствии с нашей",
        "guidesIntro": "Если у вас вопросы по отдельным функциям, ответы могут быть в руководствах:",
        "faqIntro": "По многим темам есть подробные ответы в разделе вопросов:",
        "faqLinkLabel": "Открыть помощь и инструкции",
        "responseTimeNotice": "Учтите, что в периоды высокой загрузки ответ может занять несколько дней."
    },
    "refund": {
        "title": "Политика возврата"
    },
    "terms": {
        "title": "Условия использования"
    },
    "privacy": {
        "title": "Политика конфиденциальности"
    },
    "footer": {
        "description": "Современные приложения Garmin с расширенными функциями для всех активностей.",
        "tagline": "Современные приложения Garmin с расширенными функциями для всех активностей.",
        "linksTitle": "Ссылки",
        "socialsTitle": "Соцсети",
        "terms": "Условия использования",
        "impressum": "Правовая информация",
        "privacy": "Конфиденциальность",
        "refund": "Возврат",
        "contact": "Контакты",
        "rights": "Все права защищены.",
        "links": "Ссылки",
        "contactDescription": "Вопросы или поддержка?",
        "contactLink": "Связаться",
        "copyright": "Orcatec — TitanicTurtle. Все права защищены.",
        "garminForums": "Форумы Garmin"
    },
    "tides": {
        "title": "Приливы через Stormglass.io",
        "intro": "Чтобы использовать приливы на циферблате с провайдером stormglass, зарегистрируйтесь на их сайте и получите API-ключ, который можно ввести в соответствующее поле в настройках циферблата.",
        "apiKey": {
            "title": "Копирование API-ключа",
            "description": "При копировании API-ключа убедитесь, что скопированы все символы (обычно больше 60) — иногда Android/iOS обрезают часть после «-»."
        },
        "freePlan": {
            "title": "Бесплатный план",
            "description": "Бесплатный план stormglass.io даёт 10 запросов в день — этого достаточно для данных приливов в поддерживаемых циферблатах TitanicTurtle.",
            "note": "(Если ваш циферблат поддерживает stormglass.io как погодный провайдер и вы планируете его использовать, может понадобиться отдельная подписка)"
        },
        "dataDownload": {
            "title": "Загрузка данных",
            "description": "Обычно данные приливов загружаются на несколько дней и обновляются раз в день при наличии связи с телефоном. Даже без интернета данные приливов отображаются минимум на 3 (Horizon) / 5 (Centurion) дней вперёд (зависит от циферблата и устройства)."
        },
        "initialSetup": {
            "title": "Первоначальная настройка",
            "description": "После ввода API-ключа stormglass.io в настройках загрузка и появление данных могут занять до 30 минут."
        },
        "locationUpdate": {
            "title": "Обновление местоположения",
            "description": "При смене местоположения выполните GPS-фиксацию на часах, чтобы данные приливов обновились для новой точки."
        },
        "requirements": {
            "title": "Требования",
            "bluetooth": "Убедитесь, что часы подключены по Bluetooth к телефону, на котором приложение Connect (не Connect IQ) работает хотя бы в фоне.",
            "gps": {
                "title": "GPS-фиксация",
                "description": "Если на часах отображается «GPS?», выполните GPS-фиксацию, чтобы циферблат узнал ваше местоположение.",
                "steps": {
                    "step1": "Перейдите на экран запуска активности, например «Бег», на часах",
                    "step2": "Дождитесь получения GPS-сигнала часами"
                }
            }
        }
    },
    "common": {
        "loading": "Загрузка...",
        "error": "Ошибка",
        "retry": "Повторить",
        "back": "Назад",
        "close": "Закрыть",
        "save": "Сохранить",
        "cancel": "Отмена",
        "confirm": "Подтвердить",
        "notFound": "404 — Страница не найдена"
    },
    "watchfacesOverview": {
        "title": "Все приложения",
        "loading": "Загрузка циферблатов...",
        "error": "Ошибка загрузки циферблатов",
        "retry": "Повторить",
        "noWatchfaces": "Нет доступных циферблатов"
    },
    "detailTabs": {
        "payment": "Оплата",
        "themes": "Темы",
        "info": "Информация",
        "instructions": "Инструкции",
        "instructionsIntro": "Все руководства и инструкции:",
        "noThemes": "У этого циферблата нет цветовых тем."
    },
    "watchfaceDetail": {
        "loading": "Загрузка циферблата...",
        "error": {
            "notFound": "Циферблат не найден",
            "loading": "Ошибка загрузки циферблата"
        },
        "backToOverview": "Назад к списку",
        "goToStore": "В магазин IQ",
        "goToTrial": "Пробная версия",
        "devices": "устройств",
        "russiaPaymentWarning": "В настоящее время из-за различных санкций некоторые или все способы оплаты могут не работать. К сожалению, как разработчик я не могу на это повлиять и сейчас не могу предложить собственные решения.",
        "info": {
            "title": "Возможности",
            "tides": "🌊 Информация о приливах с автообновлением",
            "weather": "🌤️ Погода от OpenWeatherMap и Yr",
            "colors": "🎨 Цветовые темы и настройки",
            "location": "📍 Определение местоположения по GPS",
            "faq": "❓ Вопросы и поддержка",
            "weatherFallback": "Если введён ключ OpenWeatherMap без подписки One Call 3.0, используется провайдер погоды «Yr»."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Как работают темы?:",
            "description": "В верхней части настроек циферблата есть «строка темы», которая отражает текущие цветовые настройки (иконки, графики, время и т.д.). Если что-то изменить (например цвет верхней секции) и нажать «Сохранить», строка темы обновится при следующем открытии настроек. Так можно сохранить цветовые настройки, скопировав и сохранив строку темы где-нибудь. Её можно делиться с другими, например в отзывах или на форуме, и применять чужие строки темы для других стилей."
        },
        "dynamicThemeSwitching": {
            "title": "Динамическое переключение тем:",
            "sunset": {
                "title": "Переключение после заката / до рассвета —",
                "description": "если поставить восклицательный знак ! перед строкой темы в поле строки темы, она сохранится как тема после заката (пример: !UEUE[UEUEEEEEEU^). Изменить можно в любой момент, введя строку с ведущим ! в поле. Чтобы убрать ночную тему, введите в поле строки темы один восклицательный знак ! — переключение прекратится."
            },
            "lowPower": {
                "title": "Переключение в режиме энергосбережения —",
                "description": "процесс такой же, как для темы заката/рассвета выше, но вместо ! поставьте # перед строкой темы (пример: #UEUE[UEUEEEEEEU^). Часы переходят в «режим энергосбережения» примерно через 10 секунд после того, как вы смотрите на часы или возвращаетесь из меню. Обычно в этом режиме по умолчанию исчезают секунды (можно изменить в настройках циферблата). Оба варианта (ночь/энергосбережение) можно комбинировать. После настройки динамическая строка темы не отображается в настройках циферблата — сохраните её отдельно, если захотите что-то изменить позже."
            }
        }
    },
    "colorThemes": {
        "clickToCopy": "Нажмите, чтобы скопировать",
        "clickToPreview": "Нажмите для предпросмотра",
        "closePreview": "Закрыть предпросмотр",
        "copied": "Скопировано!",
        "useInSettings": "Используйте в настройках циферблата",
        "guideLink": "Подробнее о темах и строках тем",
        "deviceNote": "Примечание: цветовые темы доступны не на всех устройствах.",
        "noFieldNote": "Если в настройках циферблата нет отдельного поля для цветовых схем, значит они не поддерживаются для вашей модели часов на этом циферблате."
    },
    "payment": {
        "option1": {
            "title": "Вариант 1: Garmin Pay",
            "description": "Купите платный циферблат напрямую через Garmin Pay в магазине ConnectIQ (если ваши часы поддерживаются).",
            "link": "Перейти в магазин ConnectIQ"
        },
        "option2": {
            "title": "Вариант 2: Прямая оплата по WatchfaceID",
            "description": "Если платная pro-версия не поддерживается вашими часами, можно купить ключ пробной/VX версии, введя свой WatchfaceID.",
            "vxNote": "Это ключ для VX-версии циферблата, не для версии Garmin Pay!",
            "vxLink": "Ссылка на VX-версию"
        },
        "tax": "налог",
        "wfid": {
            "description": "Введите свой WatchfaceID (указан в настройках циферблата)",
            "placeholder": "Введите WatchfaceID (5–6 цифр)",
            "guideLink": "Как найти свой WatchfaceID",
            "guideLinkShort": "Показать инструкцию"
        },
        "wfidError": {
            "letters": "WatchfaceID должен содержать только цифры",
            "tooLong": "WatchfaceID должен быть длиной 5–6 цифр",
            "invalid": "Введите корректный WatchfaceID (5–6 цифр)",
            "lengthHint": "WatchfaceID обычно состоит из 5–6 цифр. Проверьте ввод."
        },
        "errors": {
            "empty": "Введите свой WatchfaceID",
            "invalid": "Введите корректный WatchfaceID",
            "config": "Ошибка настройки оплаты",
            "checkout": "Не удалось открыть оплату. Попробуйте снова."
        },
        "buy": "Купить сейчас",
        "selectMethod": "Выберите версию",
        "versionSelectHint": "Это две отдельные версии — пожалуйста, выберите правильную:",
        "vxWarning": "VX и Elite — это отдельно загружаемые версии циферблата. Код активации для VX версии НЕ разблокирует версию Elite.",
        "beta": {
            "title": "Сейчас в бета-версии",
            "description": "В бета-фазе циферблат полностью бесплатен. После тестового периода автоматическое списание не будет. В это время тестируются новые функции. Спасибо за отзывы!",
            "descriptionApp": "Во время бета-фазы вы можете полностью бесплатно пользоваться этим приложением. После тестового периода автоматических списаний не будет. В это время тестируются новые функции. Спасибо за ваши отзывы!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Версия Elite",
            "description": "Этот циферблат доступен только через Garmin Pay в магазине ConnectIQ.",
            "comboDescription": "Покупка напрямую через Garmin Pay в магазине ConnectIQ. Это отдельная самостоятельная версия.",
            "compatibility": "Примечание: не все модели часов поддерживают Garmin Pay. Проверьте совместимость на странице магазина. Иначе скачайте VX-версию (технически идентична).",
            "storeLink": "Открыть в магазине ConnectIQ",
            "moreGuide": "Нужны подробности о разнице между Elite и VX?",
            "moreGuideLink": "Читать руководство по покупке и установке",
            "eliteNoKey": "При покупке версии Elite через Garmin Pay код разблокировки не отправляется. Версия Elite разблокируется сразу после покупки и не требует кода.",
            "accountBound": "Покупка через Garmin Pay привязана к вашему аккаунту Garmin и автоматически доступна для ваших будущих устройств (если совместимы).",
            "eliteNoKeyAndGuide": "При покупке через Garmin Pay код разблокировки не отправляется — версия Elite разблокируется сразу после покупки. Подробнее в руководстве по покупке и установке."
        },
        "vx": {
            "badge": "Все устройства",
            "title": "VX-версия",
            "description": "Совместима со всеми поддерживаемыми устройствами. Скачайте пробную версию в магазине ConnectIQ, затем активируйте здесь купленным кодом.",
            "trialNote": "VX-версия включает бесплатный пробный период. После него купите код активации ниже для постоянной разблокировки.",
            "deviceBound": "Код активации привязан к вашему устройству и разблокирует VX-версию навсегда.",
            "moreGuide": "Нужны подробности о VX, ключах или установке?",
            "moreGuideLink": "Читать руководство по покупке и установке",
            "downloadLink": "Скачать VX-версию",
            "details": {
                "line1": "После успешной оплаты ключ активации будет отправлен на email, указанный на следующем шаге.",
                "line2": "Убедитесь, что email указан верно.",
                "line3": "После оплаты проверьте папку «Спам» — письма с ключами часто попадают туда.",
                "line4": "Все платежи обрабатывает Paddle — регистрация не нужна.",
                "line5": "По вопросам поддержки используйте форму обратной связи или инструмент магазина ConnectIQ.",
                "line6": "Другие запросы обрабатываться не будут."
            }
        },
        "standalone": {
            "title": "Покупка кода активации",
            "description": "Купите код активации, введя свой WatchfaceID ниже. Код будет отправлен вам сразу."
        },
        "checkoutOpening": "Открытие оплаты...",
        "info": {
            "key": "После покупки вы получите ключ для ввода в настройках циферблата.",
            "activation": "Ключ активируется сразу после успешной оплаты.",
            "support": "По вопросам обращайтесь в поддержку.",
            "moreGuide": "Подробнее о покупке и установке"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Банковская карта"
        }
    },
    "fonts": {
        "title": "Шрифты",
        "timefonts": "Шрифты времени",
        "datafonts": "Шрифты данных"
    },
    "weather": {
        "title": "Провайдеры погодных данных",
        "intro": "У многих циферблатов на большинстве устройств есть выбор погодных провайдеров. Провайдера можно изменить в настройках приложения ConnectIQ. По умолчанию обычно выбраны погода Garmin или Yr.",
        "noData": "Если в поле погоды отображается «нет данных», загрузить погоду не удалось. Ниже шаги по получению погоды на часах.",
        "tabs": {
            "garmin": "Garmin",
            "yr": "Yr",
            "openweathermap": "OpenWeatherMap",
            "visualcrossing": "Visual Crossing",
            "location": "Местоположение"
        },
        "garmin": {
            "title": "Использование погоды Garmin:",
            "description": "Если устройство поддерживает погоду Garmin, достаточно подключить часы к телефону по Bluetooth и убедиться, что приложение Connect (не Connect IQ) работает хотя бы в фоне и имеет доступ к текущему местоположению телефона (текущее местоположение (GPS) должно быть включено).",
            "download": "Часы автоматически загрузят погодные данные из этого сервиса — это может занять несколько минут.",
            "check": "Можно проверить, отображаются ли уже погодные данные во встроенном виджете погоды Garmin на часах. Если там данных нет, циферблат их тоже не покажет — источник один.",
            "noApiKey": "Для погоды Garmin дополнительный API-ключ не нужен.",
            "location": "В некоторых циферблатах при использовании погоды Garmin отображается переданное местоположение. У погодных станций Garmin это обычно ближайший аэродром — более точное местоположение возможно только с другими провайдерами.",
            "update": "Местоположение обновляется, как только данные о местоположении активны на телефоне.",
            "noData": "Если погода не отображается или не обновляется, показывается «нет данных» — выполните шаги выше.",
            "missingData": {
                "title": "Данные, не входящие в погоду Garmin:",
                "airQuality": "Качество воздуха",
                "uvIndex": "УФ-индекс",
                "description": "Описание погоды"
            }
        },
        "yr": {
            "title": "Использование Yr:",
            "description": "Yr — сервис Норвежского метеорологического института и NRK, им можно пользоваться без API-ключа.",
            "setup": "Чтобы получать погоду от Yr, выберите его как провайдера и подключите часы к телефону по Bluetooth.",
            "connectApp": "На телефоне убедитесь, что приложение Connect (не ConnectIQ) работает хотя бы в фоне — через него часы загружают погоду из интернета.",
            "interval": "Если у циферблата есть настройка интервала обновления, при Yr минимум 10 минут.",
            "noData": {
                "title": "нет данных / неверное местоположение:",
                "description": "Если погода не загружается или местоположение неверное, обновите сохранённое местоположение циферблата.",
                "fix": "Перейдите на экран запуска активности, например «Бег», на часах и дождитесь GPS-сигнала. Погода и местоположение должны обновиться в течение нескольких минут."
            },
            "missingData": {
                "title": "Данные, которых нет в Yr:",
                "airQuality": "Качество воздуха"
            }
        },
        "openweathermap": {
            "title": "Использование OpenWeatherMap:",
            "description": "Если циферблат поддерживает OpenWeatherMap и вы хотите его использовать, нужен бесплатный API-ключ с их сайта:",
            "setup": "После получения ключа введите его в соответствующее поле в настройках циферблата (новый ключ может начать работать с задержкой до нескольких часов).",
            "connect": "Убедитесь, что часы подключены к телефону по Bluetooth и приложение Connect (не Connect IQ) работает хотя бы в фоне для загрузки погоды.",
            "gps": "Если на часах отображается «GPS?», выполните GPS-фиксацию (экран запуска активности «Бег», дождаться GPS-сигнала).",
            "uv": {
                "title": "УФ-индекс / осадки в OpenWeatherMap:",
                "oldKey": "Если у вас старый API-ключ (создан до ~февраля 2023), эти показатели доступны без ограничений.",
                "newKey": "Если ключ создан позже и вы хотите видеть эти показатели от OpenWeatherMap, может понадобиться дополнительная (бесплатная) подписка — план «One Call by Call».",
                "limit": "Первые 1000 запросов в день по этой подписке бесплатны, лимит можно установить на 1000 — этого более чем достаточно для погоды на весь день на любом из моих циферблатов."
            },
            "select": "Если циферблат поддерживает несколько сторонних погодных провайдеров, выберите OpenWeatherMap в выпадающем меню в настройках циферблата."
        },
        "visualcrossing": {
            "title": "Использование Visual Crossing:",
            "description": "Для Visual Crossing нужен бесплатный API-ключ с их сайта.",
            "setup": "После получения ключа введите его в соответствующее поле в настройках циферблата и выберите Visual Crossing как провайдера в выпадающем меню.",
            "connect": "Убедитесь, что часы подключены к телефону по Bluetooth и приложение Connect (не Connect IQ) работает хотя бы в фоне для загрузки погоды.",
            "gps": "Если на часах отображается «GPS?», выполните GPS-фиксацию (экран запуска активности «Бег», дождаться GPS-сигнала)."
        },
        "location": {
            "title": "Обновление местоположения",
            "description": "Для корректного отображения погоды циферблату нужно ваше текущее местоположение. Оно определяется по GPS.",
            "gpsFix": {
                "title": "Выполнить GPS-фиксацию:",
                "description": "Если на часах отображается «GPS?», выполните GPS-фиксацию, чтобы циферблат узнал ваше местоположение.",
                "step1": "Перейдите на экран запуска активности, например «Бег», на часах",
                "step2": "Дождитесь получения GPS-сигнала часами",
                "step3": "Вернитесь на циферблат — погода должна обновиться в течение нескольких минут"
            },
            "requirements": {
                "title": "Требования:",
                "bluetooth": "Часы должны быть подключены к телефону по Bluetooth",
                "connectApp": "Приложение Connect (не Connect IQ) должно работать хотя бы в фоне",
                "gps": "На телефоне должен быть включён GPS"
            }
        }
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Приложение Bierwandern позволяет отслеживать поход и «дополнительные кружки», которыми вы наслаждаетесь по пути. Также есть оценка промille с графиком (приблизительная) – но, пожалуйста, не воспринимайте это всерьёз!",
        "settingsHint": "На стартовом экране нажмите кнопку меню на часах, чтобы открыть настройки (на часах с двумя кнопками – длительное нажатие на сенсорный экран).",
        "disclaimer": "Расчёт промille – чисто развлекательная метрика, алгоритм оценивает алкоголь в крови по выпитым напиткам и весу тела! Не принимайте решений на основе этого значения – оно ненадёжно и не является реальным измерением алкоголя!",
        "closing": "А в остальном желаю вам отличных походов и хорошего настроения!",
        "support": "При проблемах или предложениях используйте кнопку «App Support» – спасибо."
    },
    "bodysurf": {
        "intro": {
            "title": "Что такое BodySurf?",
            "text": "BodySurf — приложение Garmin Connect IQ для бодисёрфинга. Оно использует GPS для определения заезда на волне, измеряет дистанцию и длительность каждого заезда и присваивает забавный титул по пройденной дистанции. Сессии сохраняются как активности с отдельными кругами в Garmin Connect."
        },
        "gps": {
            "title": "Перед стартом – GPS",
            "text1": "Дождитесь GPS-фикса перед началом сессии. На стартовом экране будет «Поиск GPS», затем «НАЧАТЬ, чтобы начать».",
            "text2": "Для лучшей точности приложение использует multi-GNSS / dual-band GPS, если часы поддерживают. Постойте недвижимо у воды, если фикс занимает время."
        },
        "start": {
            "title": "Экран начала",
            "startBtn": "Начните новую сессию, когда GPS готов (НАЧАТЬ = начать сессию).",
            "menuBtn": "Откройте настройки: Как пользоваться и Единицы (МЕНЮ = настройки / информация).",
            "backBtn": "НАЗАД = выйти из приложения"
        },
        "during": {
            "title": "Во время активности",
            "detect": "Поездки определяются по GPS скорости автоматически. Используйте НАЗАД для ручного начала/остановки поездки. Короткие движения менее 2 метров отбрасываются.",
            "startBtn": "НАЧАТЬ = остановить / сохранить / продолжить",
            "backBtn": "НАЗАД = ручное включение/выключение поездки",
            "live": "Во время заезда видны текущая дистанция, живой титул и «КАТАНИЕ!». После заезда титул и статистика остаются до следующего."
        },
        "stop": {
            "title": "Меню остановки",
            "resume": "Продолжить",
            "save": "Сохранить",
            "discard": "Отменить"
        },
        "after": {
            "title": "После сессии",
            "summary": "Сводка показывает время сессии, число Поездки, общую дистанцию и Лучший заезд с титулом и статистикой.",
            "rides": "Проведите, чтобы увидеть детали поездки. На часах с кнопками: << DOWN rides.",
            "finished": "Затем: Новая сессия через START или Выйти из приложения через НАЗАД."
        },
        "titles": {
            "title": "Титулы заездов",
            "intro": "Каждой поездке присваивается забавное название в зависимости от расстояния. Чем длиннее поездка, тем лучше название!",
            "colDistance": "Дистанция",
            "colTitle": "Титул",
            "th0": "Сигурка",
            "th1": "Камбала",
            "th2": "Человек-серфборд",
            "th3": "Серфер",
            "th4": "Аквамен",
            "th5": "Посейдон",
            "th6": "Нептун",
            "th7": "Покоритель волн",
            "th8": "Мастер серфинга",
            "th9": "Бог волн",
            "th10": "Легенда океана",
            "th11": "Титан волн",
            "th12": "Король океана"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Сохранённые сессии отображаются в Garmin Connect с полями: титул заезда, дистанция круга (метры), время круга (секунды) и самый длинный заезд/время на уровне сессии. Каждый заезд сохраняется как круг."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "На Instinct субдисплей показывает время, GPS и дистанцию. Используйте кнопку ВНИЗ вместо свайпа (<< DOWN rides).",
            "menu": "«Меню» слева на стартовом экране. Нажмите НАЧАТЬ, когда на субдисплее GPS ОК."
        },
        "settings": {
            "title": "Настройки",
            "units": "Единицы: переключение метрической и имперской систем для дистанции и скорости.",
            "info": "Информация: встроенная справка (Как пользоваться) по кнопкам во время активности, после сессии и на стартовом экране."
        },
        "supportBefore": "При проблемах или предложениях используйте",
        "supportLink": "форму обратной связи",
        "supportAfter": " – спасибо!"
    }
};
